/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedContactSupportButton_user = {
    readonly profile: {
        readonly displayName: string | null;
        readonly email: string | null;
    } | null;
    readonly " $refType": "PdpSharedContactSupportButton_user";
};
export type PdpSharedContactSupportButton_user$data = PdpSharedContactSupportButton_user;
export type PdpSharedContactSupportButton_user$key = {
    readonly " $data"?: PdpSharedContactSupportButton_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactSupportButton_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedContactSupportButton_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'df66edc7ccf4b474e5d0f2f2259b9b69';
export default node;
